import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import WebsiteEventDetailsLayer from "../components/WebsiteEventDetailsLayer";

const WebsiteEventViewPage = () => {
    return (
        <MasterLayout>
            <WebsiteEventDetailsLayer />
        </MasterLayout>
    );
};

export default WebsiteEventViewPage;
